import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyD6FL8aKRN02ANDTuplXI_21rYV4nLaMQk",
  authDomain: "kynzo-prod.firebaseapp.com",
  projectId: "kynzo-prod",
  storageBucket: "kynzo-prod.firebasestorage.app",
  messagingSenderId: "451085435950",
  appId: "1:451085435950:web:3c91aa95f5d1016c264bbf"
};

const app = initializeApp(firebaseConfig);

export default app;